import * as React from "react";
import { useCallback, useMemo } from "react";
import { PluginStore } from "graylog-web-plugin/plugin";
import { ClusterDeflector, SystemDeflector, SystemIndexRanges } from "@graylog/server-api";
import { DATA_TIERING_TYPE } from "components/indices/data-tiering";
import { ButtonGroup, DropdownButton, MenuItem } from "components/bootstrap";
import { defaultOnError } from "util/conditional/onError";
const _onRecalculateIndexRange = (indexSetId) => {
  if (
    // eslint-disable-next-line no-alert
    window.confirm(
      "This will recalculate index ranges for this index set using a background system job. Do you want to proceed?"
    )
  ) {
    defaultOnError(
      SystemIndexRanges.rebuildIndexSet(indexSetId),
      "Could not create a job to start index ranges recalculation",
      "Error starting index ranges recalculation"
    );
  }
};
const _onCycleDeflector = (indexSetId) => {
  if (
    // eslint-disable-next-line no-alert
    window.confirm("This will manually cycle the current active write index on this index set. Do you want to proceed?")
  ) {
    defaultOnError(
      ClusterDeflector.cycleByindexSetId(indexSetId).then(() => SystemDeflector.deflector(indexSetId)),
      "Cycling deflector failed"
    );
  }
};
const IndicesMaintenanceDropdown = ({ indexSet, indexSetId }) => {
  var _a;
  const dataTieringPlugin = PluginStore.exports("dataTiering").find(
    (plugin) => plugin.type === DATA_TIERING_TYPE.HOT_WARM
  );
  const onCycleDeflector = useCallback(() => _onCycleDeflector(indexSetId), [indexSetId]);
  const onRecalculateIndexRange = useCallback(() => _onRecalculateIndexRange(indexSetId), [indexSetId]);
  const cycleButton = useMemo(
    () => (indexSet == null ? void 0 : indexSet.writable) ? /* @__PURE__ */ React.createElement(MenuItem, { eventKey: "2", onClick: onCycleDeflector }, "Rotate active write index") : null,
    [indexSet == null ? void 0 : indexSet.writable, onCycleDeflector]
  );
  return /* @__PURE__ */ React.createElement(ButtonGroup, null, /* @__PURE__ */ React.createElement(DropdownButton, { bsStyle: "info", title: "Maintenance", id: "indices-maintenance-actions", pullRight: true }, /* @__PURE__ */ React.createElement(MenuItem, { eventKey: "1", onClick: onRecalculateIndexRange }, "Recalculate index ranges"), cycleButton, ((_a = indexSet == null ? void 0 : indexSet.data_tiering_status) == null ? void 0 : _a.has_failed_snapshot) && dataTieringPlugin && /* @__PURE__ */ React.createElement(dataTieringPlugin.DeleteFailedSnapshotMenuItem, { eventKey: "3", indexSetId })));
};
export default IndicesMaintenanceDropdown;
